module.exports = __webpack_public_path__ + "static/4-f66a8b9a14744ad12df9f4ab98290dd8.jpeg";